<template>
  <!-- Figma 57554:80668: "No results found." (h3 emphasis 20/28) + "Try a different..." (p3 muted 14/20)。
       センター揃え、bg は持たない（モーダル本体の半透明白＋blur が透ける） -->
  <div class="flex flex-col items-center gap-1 px-4 py-8 text-center font-Spectral">
    <p class="text-[20px] leading-7 text-gray9">No results found.</p>
    <p class="text-[14px] leading-5 text-gray4">Try a different keyword or explore popular destinations and categories.</p>
  </div>
</template>
